import { useState, useEffect, useCallback, useMemo } from "react";

const useFetch = ({ apiMethod, body = {}, autoFetch = true }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(autoFetch);

  const memoizedBody = useMemo(() => body, [JSON.stringify(body)]);

  const fetchData = useCallback(
    async (body) => {
      if (typeof apiMethod !== "function") {
        setError("apiMethod must be a function");
        return;
      }


      try {
        setLoading(true);
        const response = await apiMethod({
          body: { ...memoizedBody, filters: { ...body } },
        });
        const responseData = response?.data?.data;
        if (responseData) {
          setData(responseData);
          setError("");
        } else {
          setError("Invalid data format received.");
        }
      } catch (err) {
        setError(
          err?.response?.data?.message || err.message || "Something went wrong"
        );
      } finally {
        setLoading(false);
      }
    },
    [apiMethod, memoizedBody]
  );

  useEffect(() => {
    if (autoFetch) fetchData();
  }, [fetchData]);

  const setBlankResponse = () => {
    setData([]);
  };

  return { data, error, loading, refetch: fetchData, setBlankResponse };
};

export default useFetch;
